'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FileBarChart2, Gauge, Clock, Compass, Route } from 'lucide-react';
import clsx from 'clsx';

export const reportTabs = [
  {
    name: 'History Report',
    shortName: 'History',
    path: '/dashboard/report/history',
    icon: FileBarChart2,
  },
  {
    name: 'RPM & Hourmeter',
    shortName: 'RPM',
    path: '/dashboard/report/rpm',
    icon: Gauge,
  },
  {
    name: 'Expired Vessels',
    shortName: 'Expired',
    path: '/dashboard/report/expired',
    icon: Clock,
  },
  {
    name: 'Voyager Planner',
    shortName: 'Voyager',
    path: '/dashboard/report/voyager',
    icon: Compass,
  },
  {
    name: 'List Voyage',
    shortName: 'List Voyage',
    path: '/dashboard/report/list-voyage',
    icon: Route,
  },
];

export default function ReportNavTabs() {
  const pathname = usePathname();

  return (
    <div className="w-full mb-3 sm:mb-4">
      {/* Mobile: Horizontal scrollable segmented pill; Desktop: Compact inline-flex */}
      <div className="w-full sm:w-auto sm:inline-flex flex items-center overflow-x-auto no-scrollbar gap-1 p-1 rounded-xl bg-gray-100 dark:bg-gray-800/90 border border-gray-200/80 dark:border-gray-700/80 shadow-2xs">
        {reportTabs.map((tab) => {
          const Icon = tab.icon;
          const isActive =
            pathname === tab.path ||
            (tab.path === '/dashboard/report/history' &&
              (pathname === '/dashboard/report' || pathname === '/dashboard/report/'));

          return (
            <Link
              key={tab.path}
              href={tab.path}
              className={clsx(
                'flex items-center justify-center gap-1 sm:gap-1.5 h-8.5 sm:h-8 px-2 sm:px-3 rounded-lg text-xs font-medium transition-all text-center whitespace-nowrap shrink-0',
                isActive
                  ? 'bg-white dark:bg-gray-900 text-brand-600 dark:text-brand-400 font-semibold shadow-xs border border-gray-200/70 dark:border-gray-700/70'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-white/50 dark:hover:bg-gray-700/50'
              )}
            >
              <Icon
                className={clsx(
                  'w-3.5 h-3.5 shrink-0 transition-colors',
                  isActive ? 'text-brand-500 dark:text-brand-400' : 'text-gray-400 dark:text-gray-500'
                )}
              />
              <span className="sm:hidden text-[11px] truncate">{tab.shortName}</span>
              <span className="hidden sm:inline whitespace-nowrap">{tab.name}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
